import * as fromDatatype from '../datatype-library/index';

export interface bl_webhook_subscription_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  topic_hdr_guid: fromDatatype.GuidDataFieldInterface;
  url: fromDatatype.VarcharDatatypeInterface;
  auth_header_name: fromDatatype.VarcharDatatypeInterface;
  auth_header_value: fromDatatype.TextDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  notification_contact_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}

export class bl_webhook_subscription_hdr_RowClass
  implements bl_webhook_subscription_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  topic_hdr_guid: fromDatatype.GuidDataFieldInterface;
  url: fromDatatype.VarcharDatatypeInterface;
  auth_header_name: fromDatatype.VarcharDatatypeInterface;
  auth_header_value: fromDatatype.TextDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  notification_contact_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}
